<template>
  <div class="smy__card-full-box">
    <Card
      :bordered="false"
      class="smy__card-full"
    >
    <p slot="title">
      开票处理
    </p>
    <div class="search">
      <!-- 详细筛选条件 -->
      <!-- <div>
        <div
          class="search-detail"
        >
        <div class="search-detail-item">
          <Input
          class="search-input"
          placeholder="请输入代理商"
          v-model="searchForm.agent_name"
          ></Input>
        </div>
        <div class="search-detail-item">
          <Input
          class="search-input"
          placeholder="请输入对账单标题"
          v-model="searchForm.title"
          ></Input>
        </div>
        <div class="search-detail-item">
          <Input
          class="search-input"
          placeholder="请输入税务编号"
          v-model="searchForm.invoice_no"
          ></Input>
        </div>
        <div class="search-detail-item">
          <Input
          class="search-input"
          placeholder="请输入物流编号"
          v-model="searchForm.logistics_no"
          ></Input>
        </div>
        <div class="search-detail-item">
          <Input
          class="search-input"
          placeholder="请输入流水单号"
          v-model="searchForm.flow_no"
          ></Input>
        </div>
        <div class="search-detail-item">
          <DateRangePicker
            class="search-input"
            :placeholder="'请选择下单时间'"
            :value="emptyORderTime"
            @on-change="daterangeChange($event, 'balance_start_time', 'balance_end_time')"
          />
        </div>
        <div class="search-detail-item">
          <Button
            type="primary"
            class="search-button"
            @click="loadList"
          >查找</Button>
          <Button
            class="search-button"
            @click="resetSearchForm"
          >重置</Button>
        </div>
        </div>
      </div> -->
    </div>
    <!-- 工单列表 -->
    <div class="table">
      <Table
        stripe
        ref="table"
        :loading="listLoading"
        :columns="columns"
        :data="list"
      ></Table>
    </div>
    <!-- 分页控件 -->
    <Page
      show-total
      show-sizer
      class="page"
      placement="top"
      :current="pageIndex + 1"
      :total="count"
      :page-size-opts="pageSizeOpts"
      @on-change="pageIndexChange"
      @on-page-size-change="pageSizeChange"
    ></Page>
    <editSuccess
    :ApplyId="ApplyId"
    :editModal="editModal"
    @callback="loadList()"
    @backeditModal= "editModal = false"
    />
   </card>
 </div>
</template>

<script>
import { mapState } from 'vuex'

import EditSuccess from './editSuccess'

export default {
  components: {
    EditSuccess
  },
  data () {
    return {
      editModal: false,
      ApplyId: 0,
      // emptyORderTime: ['', ''],
      pageSize: 10,
      pageIndex: 0,
      listLoading: false, // 表格加载状态
      count: 0,
      list: []
      // searchForm: {
      //   agent_name: '',
      //   title: '',
      //   // balance_state: '',
      //   invoice_no: '',
      //   logistics_no: '',
      //   flow_no: '',
      //   balance_start_time: '',
      //   balance_end_time: ''
      // },
    }
  },
  computed: {
    ...mapState('table', [
      'columnsCheckedAll',
      'pageSizeOpts'
    ]),
    // 表格列 根据选中的列动态生成
    columns () {
      const allColumns = [
        {
          title: '操作',
          width: 180,
          align: 'center',
          fixed: 'right',
          render: (h, { row }) => {
            let check = h('Button', {
              props: {
                type: 'ghost',
                size: 'small'
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'IssueInvoiceDetail', params: { orderId: row.id } })
                }
              },
              style: {
              }
            }, ['查看详情'])
            let setBtn = h('Button', {
              props: {
                type: 'ghost',
                size: 'small'
              },
              on: {
                click: () => {
                  this.ApplyId = row.id
                  this.editModal = true
                }
              },
              style: {
                marginLeft: '10px'
              }
            }, ['开票成功'])
            return h('span', [
              check,
              setBtn
            ])
          }
        },
        {
          title: '申请时间',
          key: 'create_time',
          width: 180
        },
        {
          title: '发票金额',
          key: 'order_total_amount',
          width: 140
        },
        {
          title: '代理商',
          key: 'bank_name',
          width: 140
        },
        {
          title: '发票抬头',
          key: 'title',
          width: 140
        },
        {
          title: '开户行',
          key: 'bank_name',
          width: 140
        },
        {
          title: '对公账号',
          key: 'bank_account',
          width: 140
        },
        {
          title: '注册地址',
          key: 'register_addr',
          width: 140
        },
        {
          title: '公司电话',
          key: 'company_phone',
          width: 140
        },
        {
          title: '收件人',
          key: 'recipients_name',
          width: 140
        },
        {
          title: '手机号码',
          key: 'recipients_phone',
          width: 140
        },
        {
          title: ' ',
          key: ' '
        }
      ]
      return allColumns
    }
  },
  methods: {
    // 加载列表数据
    loadList () {
      this.listLoading = true
      this.$http.all([
        this.$http.get('/invoice/list', {
          params: {
            invoice_state: 1,
            pageIndex: this.pageIndex,
            pageSize: this.pageSize
          }
        }),
        this.$http.get('/invoice/count', {
          params: {
            invoice_state: 1
          }
        })
      ]).then(this.$http.spread((res1, res2) => {
        this.list = res1.data
        this.count = res2.data
        this.listLoading = false
      }))
    },
    showPicList (index) {
      let arrImg = this.urlImg
      let arr = arrImg.split(',')
      console.log(arr)
      if (arr.length !== 0) {
        arr.forEach((item) => {
          this.picList.push(item)
        })
      }
      this.picIndex = index
      this.picModel = true
    },
    // 分页 每页大小 改变回调
    pageSizeChange (pageSize) {
      this.pageSize = pageSize
      this.loadList()
    },
    // 分页 页码 改变回调
    pageIndexChange (pageIndex) {
      this.pageIndex = pageIndex - 1
      this.loadList()
    },
    // 日期 改变回调
    // daterangeChange (daterange, start, end) {
    //   if (daterange[0]) {
    //     this.searchForm[start] = daterange[0].replace('/', '-').replace('/', '-')
    //     this.searchForm[end] = daterange[1].replace('/', '-').replace('/', '-')
    //   } else {
    //     this.searchForm[start] = ''
    //     this.searchForm[end] = ''
    //   }
    //   this.emptyORderTime = [this.searchForm[start], this.searchForm[end]]
    // },
    // 重置搜索框
    // resetSearchForm () {
    //   this.emptyORderTime = ['', '']
    //   this.searchForm = {
    //     agent_name: '',
    //     title: '',
    //     // balance_state: '',
    //     invoice_no: '',
    //     logistics_no: '',
    //     flow_no: '',
    //     balance_start_time: '',
    //     balance_end_time: ''
    //   }
    //   this.loadList()
    // },
    editReport () {
      this.editReportCurstom = true
    }
  },
  created () {
    this.loadList()
  }
}
</script>

<style lang="less" scoped>
.search {
  margin-bottom: 16px;
  .search-top {
    display: flex;
    justify-content: space-between;

    .search-top-left {
      display: flex;
      width: 70%;

      .search-input {
        width: 80%;

        // margin-left: 10px;
      }

      .search-button {
        margin-left: 10px;
      }
    }

    .search-top-right {
      .filter-column {
        display: flex;
        flex-direction: column;
        overflow: hidden;
      }

      .search-button {
        margin-left: 6px;
      }
    }
  }

  .search-detail {
    display: flex;
    flex-wrap: wrap;
    height: 80px;
    transition: .5s;

    .search-detail-item {
      width: 24.25%;

      .search-input {
        width: 100%;
        margin-bottom: 10px;
      }

      .search-button {
        margin-right: 6px;
      }
    }

    .search-detail-item:nth-child(2n+1),
    .search-detail-item:nth-child(4n+2) {
      margin-right: 1%;
    }
  }

  .search-detail-close {
    height: 0;
    opacity: 0;
  }
}

.page {
  margin-top: 20px;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/handle/isuseInvoiceHandle/index.vue